import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Door from './pages/door'
import Products from './pages/products'

function App() {
  return (
    <Router>
      <Route path="/products/doors/" exact component={Products} />
      <Route path="/products/doors/:doorName" exact component={Door} />
    </Router>
  );
}

export default App;


if(document.getElementById('root')) {
  ReactDOM.render(<App />, document.getElementById('root'));
}


